<template>
  <div>
    <div class="box">
      <BInputText
        label-text="专业"
        v-model="trainMajorName"
        :maxLength="20"
        placeholder="专业名称"
      />
      <BBtnSecondary
        :img-src="require('@/assets/icon_screen.png')"
        :clicked="doSearch"
        hidden-key="true"
        btn-txt="筛选"
        style="margin-left: 30px;"
      />
    </div>
    <div class="search-result">
      <div class="search-functions-headers" style="display: flex;justify-content: flex-end;align-items: flex-end;margin-left:auto">
        <div class="search-result-summary">
          <div class="summary">专业总数：{{ trainMajorNum }}</div>
        </div>
      </div>
      <Table
        :headers="headers"
        :tableData="majorList"
        :length="totalPages"
        :total-visible="7"
        :page-num="page"
        v-model="page"
        @input="doSearch(false)"
      >
        <template v-slot:actions="item">
          <div style="display:flex;flex-direction:row;justify-content: center;">
            <div class="btn-detail" @click="handleDetail(item.data)">
              查看
            </div>
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>
<script>
import { searchList } from "@/api/displayMajorList";
import BInputText from "../../components2/BInputText";
import Table from "../../components2/Table";
import BBtnSecondary from "../../components2/BBtnSecondary";
import Hub from "../../events/Hub";

export default {
  name: "CourseManagement",
  components: {
    Table,
    BInputText,
    BBtnSecondary,
  },
  data: () => ({
    totalPages: 0,
    page: 1,
    limit: 10,
    totalCount: 0,
    headers: [
      { text: "ID", value: "indexNum", align: "center", width: "5%" },
      {
        text: "专业名称",
        value: "trainMajorName",
        width: "30%",
        align: "center",
      },
      { text: "课程数量", value: "courseNum", align: "center", width: "20%" },
      { text: "操作", value: "actions", sortable: false, align: "center" },
    ],
    trainMajorName: "",
    trainMajorNum: 0,
    majorList: [],
    totalCounts: 0,
    data: {},
    navi: [{ name: "dashboard" }, { name: "display-major-list" }],
  }),
  created() {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
      sessionStorage.removeItem("store");
    }
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.doSearch();
    });
  },
  methods: {
    doSearch(flag) {
      if (flag) {
        this.totalPages = 0;
        this.page = 1;
        this.limit = 10;
        this.totalCounts = 0;
      }
      this.searchList();
    },
    async searchList() {
      var param = {
        trainMajorName: this.trainMajorName,
        page: this.page,
        limit: this.limit,
      };     
      const data = await searchList(param);
      console.log(data)
      this.majorList = data.data.searchList;
      this.trainMajorNum = data.data.trainMajorNum;
      this.totalCounts = data.data.totalPage;
      console.log(this.totalCounts)
      this.totalPages = Math.ceil(this.totalCounts / this.limit);
      console.log(this.totalPages)
    },
    // 查看
    handleDetail(data) {
      this.$router.push({
        name: "display-course-list",
         params: {
          trainMajorName: data.trainMajorName,
          trainMajorId: data.id,
        },
      });
    },
  },
  destroyed() {
    Hub.$off("modal-confirm", this.set);
  },
  mounted() {
    this.$nextTick(
      function() {
        Hub.$on("modal-confirm", this.set);
      }.bind(this)
    );
  },
   beforeMount() {
    this.$store.commit('SET_NAVI_DATA', this.navi)
  },
};
</script>

<style scoped>
.search-result {
  display: block;
  position: relative;
  margin: 30px 25px 5px 25px;
}

.search-functions-headers {
  position: relative;
  display: flex;
  justify-content: space-between;
  top: 0;
}
.search-functions {
  position: relative;
  top: 0;
  display: flex;
}

.search-result-summary {
  display: flex;
  align-items: center;
}

.search-result-summary .summary {
  margin: 0 50px 0 0;
}

.search-result-table {
  border-spacing: 0px;
  padding-bottom: 50px;
  width: 100%;
  margin-top: 10px;
}

.table-header-row {
  height: 67px;
  background: #f6f6f6;
}

.table-header-row th {
  text-align: left;
  padding: 10px;
}

.table-result-row {
  height: 78px;
  font-weight: 500;
  color: #333333;
}

.table-result-row td {
  border-bottom: 1px solid #ebebeb;
  padding: 10px;
  text-align: left;
}

.btn-detail {
  margin: 0 20px 0 20px;
  color: #0171a3;
  cursor: pointer;
}

.btn-delete {
  color: #fd1f58;
  cursor: pointer;
}
.box {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.box-left {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
}

.box-right {
  border-top: 1px solid black;
  border-bottom: 1px solid black;
}
</style>
